export const removeFocus = elements => {
  elements.forEach(element => {
    element.setAttribute('tabindex', '-1');
  });
};

export const addFocus = elements => {
  elements.forEach(element => {
    element.setAttribute('tabindex', 0);
  });
};